import './App.css';
import Header from './components/Header';
import InputContainer from './components/InputContainer';

const App = () => {
  return (
    <div className='App'>
      <Header />
      <InputContainer />
    </div>
  );
};

export default App;
